import { render, staticRenderFns } from "./PhotoSelector2.vue?vue&type=template&id=66692c68&scoped=true&"
import script from "./PhotoSelector2.vue?vue&type=script&lang=js&"
export * from "./PhotoSelector2.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSelector2.vue?vue&type=style&index=0&id=66692c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66692c68",
  null
  
)

export default component.exports